import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AIChatBotComponent from "./AIChatBotComponent"

const AIChatBot = ()=>{

    const { orgRef } = useParams();

    const [isIframeMode, setIsIframMode] = useState(true);

    return (
        <AIChatBotComponent orgRef={orgRef}  iframeMode={isIframeMode}/>
    )
}

export default AIChatBot;